(function () {
    var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
    if (isNaN(msie)) {
        msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
    }

    var module = angular.module('authentication', ['ngRoute', 'components']);

    module.config(['$sceProvider', '$routeProvider', function ($sceProvider, $routeProvider) {

        if (msie && document.documentMode < 8)
                $sceProvider.enabled(false);

        $routeProvider.when('/forgot/', {
            templateUrl: '/authentication/forgotpw/',
            id: 'forgot'
        });

        $routeProvider.when('/forgotemail/', {
            templateUrl: '/authentication/forgotemail/',
            id: 'forgotemail'
        });

        $routeProvider.when('/changeemail/', {
            templateUrl: '/authentication/changeemail/',
            id: 'changeemail'
        });

        $routeProvider.when('/', {
            templateUrl: '_login.html',
            id: 'index'
        });

        $routeProvider.otherwise({
            redirectTo: '/'
        });
    }]);

    module.factory('authService', ['$q', '$http', function ($q, $http) {
        function login(credentials) {
            return $http.post('/Authentication/SiteLogin/', credentials);
        }

        function resetPassword(credentials) {
            return $http.post('/Authentication/ChangePassword/', credentials);
        }

        function forgotPassword(email) {
            return $http.post('/Authentication/ForgotPassword/', { userEmail: email });
        }

        function forgotEmail(handle, password, birthmonth, birthday, birthyear, postal, countrycode, statecode, citycode) {
            return $http.post('/Authentication/ForgotEmail/', {
                handle: handle,
                password: password,
                birthmonth: birthmonth,
                birthday: birthday,
                birthyear: birthyear,
                postalcode: postal,
                countrycode: countrycode,
                statecode: statecode,
                citycode: citycode
            });
        }

        function changeEmail(email) {
            return $http.post('/EmailValidation/Interstitial/Update/', { email: email });
        }

        return {
            LoginWith: login,
            RetrievePasswordBy: forgotPassword,
            ResetPassword: resetPassword,
            RetrieveEmailBy: forgotEmail,
            ChangeEmailTo: changeEmail
        };
    }]);

    module.directive('submit', ['authService', function (authService) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attr, ctrl) {
                var submitLogin = function () {
                    var credentials = ctrl.$viewValue.user;

                    authService.LoginWith(credentials).then(function (response) {
                        var data = response.data;

                        // Successful login - redirect to desired path
                        if (angular.isDefined(data.RedirectToUrl) && data.RedirectToUrl !== null) {
                            location.href = data.RedirectToUrl;
                            return false;
                        }

                        // Failed with error messages
                        if (data.Success === false) {
                            scope.processMessages(response.data.Messages, true);
                            return false;
                        }

                        // Successful login - redirect to userhome
                        if (angular.isDefined(data.RedirectUrl) && data.RedirectUrl !== null) {
                            location.href = data.RedirectUrl;
                            return false;
                        }
                    },
                    function (reason) {
                        ctrl.$viewValue.submitting = false;
                        console.log(reason);
                    });
                };

                var resetPassword = function () {
                    var credentials = ctrl.$viewValue.user;
                    authService.ResetPassword(credentials).then(function (response) {
                        console.log(response.data);
                        if (response.data && response.data.Success === true) {
                            scope.setSuccessView();
                            if (response.data.RedirectUrl && response.data.RedirectUrl !== '') {
                                scope.model.redirectUrl = response.data.RedirectUrl;
                            }
                            angular.element('#validationError').hide();
                        } else {
                            if (response.data && response.data.Messages && response.data.Messages.length > 0) {
                                angular.element('#validationError').text(response.data.Messages[0].Text);
                            }
                            angular.element('#validationError').show();
                            scope.model.error = true;
                        }
                    });
                }

                var retrievePassword = function () {
                    var email = ctrl.$viewValue.user.email;

                    authService.RetrievePasswordBy(email).then(
                        function (response) {
                            var data = response.data;
                            var hasErrors = data.Success === false;
                            if (hasErrors === false) {
                                scope.setSuccessView();
                            }
                            scope.processMessages(response.data.Messages, hasErrors);
                        },
                        function () {
                            ctrl.$viewValue.submitting = false;
                        }
                    );
                };

                var retrieveEmail = function (params) {
                    var handle = ctrl.$viewValue.user.handle;
                    var password = ctrl.$viewValue.user.password;
                    var birthmonth = ctrl.$viewValue.user.birthmonth;
                    var birthday = ctrl.$viewValue.user.birthday;
                    var birthyear = ctrl.$viewValue.user.birthyear;
                    var postal = ctrl.$viewValue.user.postalcode;
                    var countrycode = ctrl.$viewValue.user.countrycode;
                    var statecode = ctrl.$viewValue.user.statecode;
                    var citycode = ctrl.$viewValue.user.citycode;

                    authService.RetrieveEmailBy(handle, password, birthmonth, birthday, birthyear, postal, countrycode, statecode, citycode).then(
                        function (response) {
                            var data = response.data;
                            if (data && data.Success === true) {
                                if (params.inApp) {
                                    scope.model.user.email = data.Data.email;
                                    scope.setSuccessView();
                                } else if (data.RedirectUrl) {
                                    location.href = data.RedirectUrl;
                                }
                            }
                            else {
                                angular.element(document.getElementById("error")).css({ 'display': 'block' });
                                ctrl.$viewValue.submitting = false;
                            }
                        },
                        function () {
                            ctrl.$viewValue.submitting = false;
                        }
                    );
                };

                var changeEmail = function () {
                    var email = ctrl.$viewValue.user.email;
                    authService.ChangeEmailTo(email).then(
                        function (response) {
                            var data = response.data;
                            var hasErrors = data.Success === false;
                            if (hasErrors === false) {
                                location.href = '/login/continuetosite';
                            }
                            else {
                                angular.element('#error').show();
                                ctrl.$viewValue.submitting = false;
                            }
                        },
                        function () {
                            ctrl.$viewValue.submitting = false;
                        }
                    );
                };

                element.on('submit', function (e) {
                    e.preventDefault();
                    ctrl.$viewValue.submitting = true;
                    scope.resetMessages();

                    switch (attr.submit) {
                        case 'login':
                            submitLogin();
                            break;
                        case 'forgotPW':
                            retrievePassword();
                            break;
                        case 'resetPass':
                            resetPassword();
                            break;
                        case 'forgotEmail':
                            retrieveEmail({});
                            break;
                        case 'forgotEmail-App':
                            retrieveEmail({inApp: true});
                            break;
                        case 'changeEmail':
                            changeEmail();
                        default:
                            return false;
                    }
                });
            }
        };
    }]);
   
    module.controller('authCtrl',
        ['$scope', '$sce', '$timeout', '$route', '$sniffer', '$locale', 'authService',
            function ($scope, $sce, $timeout, $route, $sniffer, $locale, authService) {
                var viewModel = LoginModel || {};
                var self = this;
                var trustedHtml = {};

                this.init = function () {
                    $scope.model = {
                        user: {
                            handle: '',
                            password: '',
                            email: '',
                            countrycode: '',
                            citycode: '',
                            statecode:'',
                            remember: true
                        },
                        messages: [],
                        messageGlyph: 'A',
                        showHints: $sniffer.msie && $sniffer.msieDocumentMode < 10,
                        status: 'success',
                        submitting: false,
                        showReturnToSignin: true
                    };

                    $scope.months = this.GetTranslatedMonths();
                    angular.extend($scope.model, viewModel);
                    $scope.model.user.handle = viewModel.PersistedHandle;

                    // Server error handler
                    if (viewModel.Messages.length) {
                        $timeout(function () {
                            $scope.processMessages(viewModel.Messages, true);
                        }, 5);
                    }
                };

                this.GetTranslatedMonths = function () {
                    return [MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev1'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev2'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev3'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev4'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev5'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev6'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev7'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev8'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev9'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev10'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev11'),
                            MatchCore.UI.Site.Translate.getTranslation('MatchContent.MobileWeb.SelectLists.MonthAbbrev12')];
                };

                this.setGlyph = function (type) {
                    switch (type) {
                        case 'success': return "A";
                        case 'error': return "!";
                    }
                    return '';
                };

                this.trustAsHtml = function (html) {
                    return trustedHtml[html] || (trustedHtml[html] = $sce.trustAsHtml(html));
                };

                $scope.$on("$routeChangeSuccess", function ($event, current) {
                    $scope.model.view = current.id;
                    $scope.resetMessages();

                    switch (current.id) {
                        case 'index':
                            $scope.model.DetourMessage.CurrentTitle = $scope.model.DetourMessage.MessageTitle;
                            $scope.model.DetourMessage.CurrentBody = $scope.model.DetourMessage.MessageBody;
                            $scope.autoFocusField = ($scope.model.user.handle === '') ? "handle" : "password";

                            // Load faceboook SDK
                            $timeout(function () {
                                if (typeof FB !== "undefined") {
                                    FB.XFBML.parse();
                                } else {
                                    Cortado.Facebook.connect();
                                }
                            }, 100);

                            break;
                        case 'forgot':
                            $scope.model.DetourMessage.CurrentTitle = $scope.model.DetourMessage.ForgotTitle;
                            $scope.model.DetourMessage.CurrentBody = null;
                            $scope.model.showReturnToSignin = (Cortado.Uri(location.href).params("as")) ? false : true;
                            $scope.autoFocusField = "userEmail";
                            break;
                    };
                });

                $scope.processMessages = function (messages, hasErrors) {
                    if (hasErrors) {
                        $scope.model.status = 'error';
                        $scope.model.messageGlyph = self.setGlyph('error');
                    }

                    angular.forEach(messages, function (value, key) {
                        $scope.model.messages[key] = value;
                        $scope.model.submitting = false;
                    });
                };

                $scope.redirect = function () {
                    if ($scope.model.redirectUrl)
                        location.href = $scope.model.redirectUrl;
                }

                $scope.resetMessages = function () {
                    $scope.model.status = 'success';
                    $scope.model.messageGlyph = self.setGlyph('success');
                    $scope.model.messages = [];
                };

                $scope.setSuccessView = function () {
                    angular.element(document.getElementById("reset")).css({'display': 'none'});
                    angular.element(document.getElementById("confirmation")).css({'display': 'block'});
                }

                $scope.daysInMonth = function () {
                    var year = $scope.model.user.birthyear;
                    var month = $scope.model.user.birthmonth;
                    return (year == undefined || month == undefined || year == ' ' || month == ' ')
                        ? 31 : new Date(year, month, 0).getDate();
                };

                this.init();
            }
        ]);

    module.directive('match', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                match: '='
            },
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch(function () {
                    var modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue;
                    return (ctrl.$pristine && angular.isUndefined(modelValue)) || scope.match === modelValue;
                }, function (currentValue) {
                    ctrl.$setValidity('match', currentValue);
                });
            }
        };
    });
}());